





























import {
  defineComponent,
  useRoute,
} from '@nuxtjs/composition-api';
import { SfImage } from '~/components/StorefrontUi';
import LazyHydrate from 'vue-lazy-hydration';
import { addBasePath } from '~/helpers/addBasePath';
import SecondaryFooter from '~/components/SecondaryFooter/SecondaryFooter.vue';

export default defineComponent({
  name: 'AuthLayout',
  components: {
    SfImage,
    LazyHydrate,
    SecondaryFooter,
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
  },
  setup() {
    const route = useRoute();

    return {
      route,
      addBasePath,
    };
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
});
